module.exports = __webpack_public_path__ + "img/1 (48).d7e3475d.png";